const familyHistoryDiagnoses = [
  'No significant family history',
  'Memory impairment',
  'Stroke',
  'Hypertension (High blood pressure)',
  'Myocardial infarction (heart disease)',
  'Respiratory disease',
  'Overweight - obesity',
  'Diabetes',
  'Osteoarthritis',
  'Cancer',
  'Hematological disorder',
  'Autoimmune disease',
  'Depression',
  'Anxiety',
  'Bipolar disorder',
  'Schizophrenia',
];

export default familyHistoryDiagnoses;
